import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { VoucherInputSchema } from "../validation-schema";

const _excludeKeys = ["hotelID", "voucherID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type FormModel = AutoGeneratorForFormModel<VoucherInputSchema, ExcludeKeys, undefined>;
